const Tab = ({ children, value, index }) => {
  return value === index ? children : null;
};

export default Tab;
